const PrivacyPage = () => {
  return (
    <div className="min-h-screen pt-24 md:pt-32 bg-[#FAFAFA]" data-testid="privacy-page">
      <div className="container-elegant py-8 md:py-16">
        <div className="max-w-3xl mx-auto">
          <p className="text-malva-dark font-sans text-sm tracking-[0.3em] uppercase mb-4">
            Legal
          </p>
          <h1 className="font-serif text-4xl md:text-5xl text-gray-800 mb-8">
            Privacy Policy
          </h1>
          
          <div className="prose prose-lg max-w-none space-y-8">
            <p className="text-gray-500">
              Last updated: December 2024
            </p>

            <section className="card-elegant p-6">
              <h2 className="font-serif text-2xl text-gray-800 mb-4">1. Introduction</h2>
              <p className="text-gray-600 leading-relaxed">
                At Reva Dining, we are committed to protecting your privacy and ensuring the 
                security of your personal information. This policy outlines how we collect, use, 
                and safeguard your data when you use our website and services.
              </p>
            </section>

            <section className="card-elegant p-6">
              <h2 className="font-serif text-2xl text-gray-800 mb-4">2. Information We Collect</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                We may collect the following types of information:
              </p>
              <ul className="text-gray-600 list-disc list-inside space-y-2">
                <li><strong className="text-gray-700">Personal Information:</strong> Name, email address, phone number, and delivery address</li>
                <li><strong className="text-gray-700">Reservation Details:</strong> Date, time, party size, and special requests</li>
                <li><strong className="text-gray-700">Order Information:</strong> Items ordered, payment details, and order preferences</li>
                <li><strong className="text-gray-700">Usage Data:</strong> Browser type, IP address, and pages visited</li>
              </ul>
            </section>

            <section className="card-elegant p-6">
              <h2 className="font-serif text-2xl text-gray-800 mb-4">3. How We Use Your Information</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Your information is used to:
              </p>
              <ul className="text-gray-600 list-disc list-inside space-y-2">
                <li>Process reservations and orders</li>
                <li>Communicate about your bookings and deliveries</li>
                <li>Improve our services and customer experience</li>
                <li>Send promotional materials (with your consent)</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section className="card-elegant p-6">
              <h2 className="font-serif text-2xl text-gray-800 mb-4">4. Data Security</h2>
              <p className="text-gray-600 leading-relaxed">
                We implement industry-standard security measures to protect your personal information. 
                Payment processing is handled by Stripe, which maintains PCI-DSS compliance. We never 
                store complete credit card numbers on our servers.
              </p>
            </section>

            <section className="card-elegant p-6">
              <h2 className="font-serif text-2xl text-gray-800 mb-4">5. Contact Us</h2>
              <p className="text-gray-600 leading-relaxed">
                For privacy-related inquiries or to exercise your rights, please contact us at:{' '}
                <a href="mailto:bookings@revadining.co.uk" className="text-malva-dark hover:text-malva-darker transition-colors">
                  bookings@revadining.co.uk
                </a>
              </p>
              <p className="text-gray-500 mt-4">
                Reva Dining<br />
                45-47 York St<br />
                Twickenham, TW1 3LP
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
